export class EventCategory{
    id: string
    name: string
    isMultiple: boolean
}

export class Event {
    id: string
    name: string
    description: string
    location: string
    status: number
    eventCategoryId: string
    eventCategoryName: string
    startDate: string
    endDate: string
    image: string
    applicationEndDate: string
    isAvailableAllUser: boolean
    eventProperties: []
}

export class EventProperty {
    id: string
    eventId: string
    volunteerRoleTypeId: string
    applicationEndDate: string
    description: string
    maxApplication: number
}